module.exports = __webpack_public_path__ + "static/media/Event_details.3a75a627.gif";